module.exports = __webpack_public_path__ + "officialStatic/img/xPartner3.75a1874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/xPartner3.png
// module id = Z96X
// module chunks = 0